// Module
var code = "<tr> <td colspan=\"2\" class=\"table-sub-head\"> <span data-bind=\"text: _dataRole.Name\"></span> </td> </tr>";
// Exports
export default code;